import {apiFetch} from 'src/api/fetch'

import {type JobLoads, jobLoadsSchema, type LoadEntryInput, loadEntryRequestSchema} from './schemas'

export async function getJobLoads(jobId: string): Promise<JobLoads> {
    return jobLoadsSchema.parse(await apiFetch<unknown>(`/jobs/${jobId}/load-entries`))
}

export async function createJobLoadEntry(jobId: string, input: LoadEntryInput): Promise<JobLoads> {
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/load-entries`, {
        method: 'POST',
        body: JSON.stringify(loadEntryRequestSchema.parse(input)),
    })
    return jobLoadsSchema.parse(raw)
}

export async function updateJobLoadEntry(
    jobId: string,
    entryId: string,
    input: LoadEntryInput,
): Promise<JobLoads> {
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/load-entries/${entryId}`, {
        method: 'PATCH',
        body: JSON.stringify(loadEntryRequestSchema.parse(input)),
    })
    return jobLoadsSchema.parse(raw)
}

export async function voidJobLoadEntry(
    jobId: string,
    entryId: string,
    reason: string,
): Promise<JobLoads> {
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/load-entries/${entryId}/void`, {
        method: 'POST',
        body: JSON.stringify({reason: reason.trim() || null}),
    })
    return jobLoadsSchema.parse(raw)
}
